<template>
    <div>
        <div class="card">
            <div class="card-header header-elements-inline bg-white">
                <h5 class="card-title">Kopplade kortserier/kortbeställningar</h5>
                <div class="header-elements">
                    <button type="button" class="btn btn-light mr-1" @click="showModalCopyConnectCardSeries"><i class="icon-plus3 mr-1"></i>Kopiera koppling</button>
                    <button type="button" class="btn btn-light" @click="showModalConnectCardSeries"><i class="icon-plus3 mr-1"></i>Koppla kortserie</button>
                </div>
            </div>
            <div>
                <table class="table table-xs">
                    <thead>
                        <tr>
                            <th colspan="2">Kortserie</th>
                            <th>OrderID</th>
                            <th>Kund</th>
                            <th>Koppling</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="busy">
                        <tr>
                            <td colspan="4" class="text-center py-5"><i class="icon-spinner2 spinner"></i></td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="connected && connected.length > 0">
                        <tr v-for="(c, c_index) in connected" :key="'c-' + c_index">
                            <td>
                                <a :href="'/cardseries/' + c.CardSeriesID" target="_blank">{{ c.CardSeriesID }}</a>
                            </td>
                            <td>
                                <a :href="'/cardseries/' + c.CardSeriesID" target="_blank">{{ c.SeriesName }}</a>
                            </td>
                            <td>
                                <a v-if="c.CardOrderID > 0" :href="'/cardorders/' + c.CardOrderID" target="_blank">{{ c.CardOrderID }}</a>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <a v-if="c.CardOrderID > 0 && c.CustomerID" :href="'/customers/' + c.CustomerID" target="_blank">{{ c.CompanyName }}</a>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <span v-if="c.CardOrderID > 0">ORDER</span>
                                <span v-else>KORTSERIE</span>
                                <span v-if="c.via_CardSeriesID" class="text-muted ml-1">
                                    via kortserie
                                    <a :href="'/cardseries/' + c.via_CardSeriesID" target="_blank">{{ c.via_CardSeriesID }}</a>
                                </span>
                            </td>
                            <td class="text-right">
                                <a
                                    :href="'/product_range/' + (c.via_CardSeriesID || c.CardSeriesID) + '/' + (c.CardOrderID > 0 ? c.CardOrderID : 0)"
                                    target="_blank"
                                >
                                    Redigera{{ c.via_CardSeriesID ? ' källa' : '' }} &#187;
                                </a>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="4" class="text-center py-5"><i>Inga kopplade kortserier/kortbeställningar...</i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="connected && connected.length > 0" class="card-footer">
                <limitless-button
                    ref="btnremovefromallcards"
                    btn-class="btn-danger"
                    icon="icon-cross"
                    saved-text="OK"
                    error-text="Avbruten"
                    @click="removeFromAllCards"
                >
                    Ta bort från alla kort
                </limitless-button>
            </div>
        </div>

        <b-modal
            id="modal_connect_cardseries"
            title="Lägg till produkt på kortserier:"
            @ok="connectCardSeries"
        >
            <div v-if="product">
                <div>Produktens inköpspris: {{ product.ProdNetPrice }} kr</div>
                <div>Produktens inköpspris inkl frakt: {{ parseFloat(product.ProdNetPrice) + parseFloat(product.FreightPrice) }} kr</div>
                <table class="table table-xs mb-3">
                    <thead>
                        <tr>
                            <th colspan="2">Korterie</th>
                            <th class="text-right">Pris</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="connect_card_series.length > 0">
                            <tr v-for="(c, c_index) in connect_card_series" :key="'c-' + c_index">
                                <td>{{ c.CardSeriesID }}</td>
                                <td>{{ c.SeriesName }}</td>
                                <td class="text-right">{{ c.CardPrice > 0 ? c.CardPrice + ' kr' : '' }}</td>
                                <td class="text-right">
                                    <button type="button" class="btn btn-light btn-sm" @click="connect_card_series.splice(c_index, 1)"><i class="icon-cross"></i></button>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="4" class="text-muted">Inga korterier valda</td>
                        </tr>
                    </tbody>
                </table>
                <card-serie-filter
                    v-model="selected_card_serie"
                    :reduce="(opt) => opt.id"
                    :selectable="(opt) => !selected_card_series.includes(opt.id) && !parseInt(opt.ProductRangeCardSeriesID, 10)"
                    @option:selected="addToConnect"
                    placeholder="Lägg till kortserie att koppla"
                >
                    <template #option="{ CardSeriesID, SeriesName, CardPrice }">
                        <div class="d-flex flex-row">
                            <span>{{ CardSeriesID }} - {{ SeriesName }}</span>
                            <span style="margin-left: auto">{{ CardPrice > 0 ? CardPrice + 'kr' : '' }}</span>
                        </div>
                    </template>
                </card-serie-filter>
            </div>
            <template #modal-footer="{ ok, cancel }">
                <button type="button" class="btn btn-light" @click="cancel()">Avbryt</button>
                <limitless-button ref="btnaddcardseries" type="button" @click="ok()" icon="icon-floppy-disk">Lägg till</limitless-button>
            </template>
        </b-modal>

        <b-modal
            id="modal_copy_connect"
            title="Kopiera kort-kopplingar från en annan produkt"
            @ok="copyConnectCardSeries"
        >
            <div v-if="product">
                <div class="alert alert-warning alert-styled-left">
                    OBS! Befintliga kopplingar kommer att skrivas över.
                </div>
                <product-filter
                    v-model="copy_from_product"
                    :reduce="(opt) => opt.ProdID"
                    placeholder="Välj produkt att kopiera från"
                    show-status
                ></product-filter>
            </div>
            <template #modal-footer="{ ok, cancel }">
                <button type="button" class="btn btn-light" @click="cancel()">Avbryt</button>
                <limitless-button ref="btncopyconnect" type="button" @click="ok()" icon="icon-floppy-disk">Kopiera kort-koppling</limitless-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import { formatDateTime } from '@services/Helpers';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import CardSerieFilter from '@components/Filters/CardSerieFilter.vue';
import ProductFilter from '@components/Filters/ProductFilter.vue';

export default {
    name: 'ProductEditorCards',
    components: {
        ProductFilter,
        CardSerieFilter,
        LimitlessButton,
    },
    props: {
        id: {
            default: 'new',
        },
    },
    created() {
        this.getProduct();
        this.getData();
    },
    data: () => ({
        busy: true,
        busy_remove: false,
        product: null,
        not_found: false,
        error: false,
        connected: [],
        selected_card_serie: null,
        connect_card_series: [],
        copy_from_product: null,
    }),
    methods: {
        formatDateTime,
        getProduct() {
            apiClient.get('/vue/products/' + this.id + '/info').then((response) => {
                this.product = response.data.product;
                this.not_found = false;
                this.error = false;
            }).catch((error) => {
                this.product = null;
                if (error.response) {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    } else {
                        this.error = true;
                    }
                }
            });
        },
        getData() {
            apiClient.get('/vue/products/' + this.id + '/cards_and_orders')
                .then((response) => {
                    if (response.data) {
                        this.connected = response.data;
                    }
                })
                .finally(() => {
                    this.busy = false;
                });
        },
        showModalConnectCardSeries() {
            this.$root.$bvModal.show('modal_connect_cardseries');
        },
        showModalCopyConnectCardSeries() {
            this.$root.$bvModal.show('modal_copy_connect');
        },
        connectCardSeries(e) {
            e.preventDefault();
            this.busy_saving = true;
            apiClient.post('/vue/products/' + this.id + '/cards_and_orders', { card_serie_ids: this.connect_card_series.map((opt) => opt.CardSeriesID) })
                .then(() => {
                    this.$refs.btnaddcardseries.triggerSaved();
                    this.getData();
                    this.$root.$bvModal.hide('modal_connect_cardseries');
                    this.connect_card_series = [];
                })
                .catch(() => {
                    this.$refs.btnaddcardseries.triggerFailed();
                })
                .finally(() => {
                    this.busy_saving = false;
                });
        },
        copyConnectCardSeries(e) {
            e.preventDefault();
            this.busy_saving = true;
            apiClient.post('/vue/products/' + this.id + '/cards_and_orders', { copy_from_product: this.copy_from_product })
                .then(() => {
                    this.$refs.btncopyconnect.triggerSaved();
                    this.getData();
                    this.$root.$bvModal.hide('modal_copy_connect');
                    this.copy_from_product = null;
                })
                .catch(() => {
                    this.$refs.btncopyconnect.triggerFailed();
                })
                .finally(() => {
                    this.busy_saving = false;
                });
        },
        addToConnect(option) {
            this.connect_card_series.push(option);
            this.selected_card_serie = null;
        },
        async removeFromAllCards() {
            const { value: input } = await this.$swal({
                title: 'Vill du ta bort produkten från alla kort?',
                html: 'Produkten finns på ' + this.connected.length + ' olika kort!<strong><br><br>Vi kan inte få tillbaka datan, är du säker?</strong><br><br>Skriv ordet JA i rutan nedan om du är <strong>helt säker</strong>, klicka sedan OK',
                icon: 'warning',
                showCancelButton: true,
                input: 'text',
                inputPlaceholder: 'Skriv JA för att bekräfta',
                confirmButtonText: 'OK',
                cancelButtonText: 'Avbryt',
                confirmButtonClass: 'btn btn-danger',
            });
            if (input === 'JA') {
                this.busy_remove = true;
                await apiClient.delete('/vue/products/' + this.id + '/cards_and_orders')
                    .then(() => {
                        this.$refs.btnremovefromallcards.triggerSaved();
                    })
                    .finally(() => {
                        this.busy_remove = false;
                        this.getData();
                    });
            } else {
                this.$refs.btnremovefromallcards.triggerFailed();
            }
        },
    },
    computed: {
        selected_card_series() {
            return [
                ...(Array.isArray(this.connected) ? this.connected.filter((c) => !c.CardOrderID).map((c) => c.CardSeriesID) : []),
                ...(Array.isArray(this.connect_card_series) ? this.connect_card_series.filter((c) => !c.CardOrderID).map((c) => c.CardSeriesID) : []),
            ];
        },
    },
};
</script>
